import { TypeChecker } from '@attain-apps/type-guards'

import type * as ecModels from '../../../models'

import type * as models from './models'
import type { Plugin } from './plugin'

export class Selectors<TTypeParams extends ecModels.TypeParams.Constraint> {
  /**
   * @see {@link models.Lookup}
   */
  // NOTE: intentionally not typed here so that type can be inferred
  public readonly lookup

  /**
   * Number of entities currently cached
   */
  // NOTE: intentionally not typed here so that type can be inferred
  public readonly cachedCount

  /**
   * @see {@link models.Lookup}
   */
  // NOTE: intentionally not typed here so that type can be inferred
  public readonly getCachedEntity

  /**
   * @see {@link models.Lookup}
   */
  // NOTE: intentionally not typed here so that type can be inferred
  public readonly getCachedEntities

  constructor(plugin: Plugin<TTypeParams>) {
    this.lookup = plugin.feature.state.project(state => state.entities)
    this.cachedCount = plugin.feature.state.project(state => state.cachedCount)

    this.getCachedEntity = plugin.feature.createSelectorMethod(
      (id: ecModels.EntityId) =>
        this.lookup.project(lookup => lookup[id]).asSelector,
    )
    this.getCachedEntities = plugin.feature.createSelectorMethod(
      (ids?: readonly ecModels.EntityId[]) =>
        this.lookup.project(lookup =>
          ids === undefined ? Object.values(lookup) : ids.map(id => lookup[id]),
        ).asSelector,
    )
  }
}
